/**
 * Capacity pressure vocabulary, shared by every load meter.
 *
 * One slice of the base-view stylesheet. `styles/index.ts` concatenates
 * every slice into the single sheet `injectStyles` mounts — the split is
 * about OWNERSHIP, not about emitting more than one style element.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below
 * is one template literal and a stray backtick terminates it. That has
 * broken the build twice, both times with esbuild pointing at a line ten
 * rows away from the cause. Write class names in plain text.
 */
export default `
/* ── Capacity pressure ────────────────────────────────────────────────────
   One vocabulary shared by the HUD's load meter and the paperdoll's three
   capacity meters. Thresholds live in ui/capacity.ts: orange at 10% of the
   cap still free, red at 1% or less.

   Moss -> warn -> rust is the Codex's own status ramp. Deliberately NOT
   .hazard-band even at critical: that stripe means blocked/dangerous, and a
   full bag is neither — it is a full bag. */
.bv-cap-ok .bv-hud-carry-fill, .bv-cap-ok .bv-pd-cap-fill {
  background: linear-gradient(90deg, var(--moss-dark), var(--moss));
}
.bv-cap-warn .bv-hud-carry-fill, .bv-cap-warn .bv-pd-cap-fill {
  background: linear-gradient(90deg, #b3712a, var(--warn));
}
.bv-cap-critical .bv-hud-carry-fill, .bv-cap-critical .bv-pd-cap-fill {
  background: linear-gradient(90deg, #8f2f1e, var(--rust));
}
.bv-cap-warn .bv-hud-carry .bv-hud-inbar, .bv-cap-warn .bv-pd-cap-head span:last-child {
  color: var(--warn);
}
.bv-cap-critical .bv-hud-carry .bv-hud-inbar, .bv-cap-critical .bv-pd-cap-head span:last-child {
  color: var(--rust);
}
`;
